"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _CardMedia = _interopRequireDefault(require("@material-ui/core/CardMedia"));

var _CardHeader = _interopRequireDefault(require("@material-ui/core/CardHeader"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    avatar: {
      backgroundColor: theme.palette.primary.main
    },
    media: {
      paddingTop: '50%'
    }
  };
});

var SearchResultCardBody = function SearchResultCardBody(_ref) {
  var coverSrc = _ref.coverSrc,
      title = _ref.title,
      subTitle = _ref.subTitle,
      nbResults = _ref.nbResults,
      noMedia = _ref.noMedia;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, !noMedia ? /*#__PURE__*/_react["default"].createElement(_CardMedia["default"], {
    className: classes.media,
    image: coverSrc,
    title: title
  }) : '', /*#__PURE__*/_react["default"].createElement(_CardHeader["default"], {
    avatar: /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
      "aria-label": "Recipe",
      className: classes.avatar
    }, nbResults > 98 ? '99+' : nbResults),
    title: title,
    subheader: subTitle
  }));
};

SearchResultCardBody.propTypes = {
  className: _propTypes["default"].string,
  coverSrc: _propTypes["default"].string.isRequired,
  key: _propTypes["default"].string.isRequired,
  nbResults: _propTypes["default"].number.isRequired,
  noMedia: _propTypes["default"].bool.isRequired,
  subTitle: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string.isRequired
};
SearchResultCardBody.defaultProps = {
  className: '',
  noMedia: false
};
var _default = SearchResultCardBody;
exports["default"] = _default;